import React from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import toast from "react-hot-toast";

export default function DeleteFeaturedProfileModal({ hide, ...props }) {
  const { http } = global.services;
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async () => {
    if (loading) return;
    setLoading(true);
    try {
  const targetId = props?.id || props?.user_profile_selection_id || props?.user_profile?.id;
  if (!targetId) throw new Error("Missing id");
  const res = await http.delete(`user-profile-selections/${targetId}`);
      if (res) {
        toast.success("Deleted");
        hide("delete");
      }
    } catch (err) {
      console.log("error@deleteFeaturedProfile", err);
      toast.error(err?.data?.message || "Delete failed");
    } finally {
      setLoading(false);
    }
  };

  const Footer = () => (
    <div className="relative flex flex-row items-center justify-end space-x-2">
      <Button
        key="cancel-btn-featured"
        buttonName="Cancel"
        buttonClass="bg-thBg py-3 px-9"
        buttonTextClass="text-black text-sm font-bold"
        onClick={() => hide()}
      />
      <Button
        key="delete-btn-featured"
        buttonName="Yes, Delete"
        buttonClass="bg-danger py-3 px-12"
        buttonTextClass="text-white text-sm font-bold"
  onClick={handleSubmit}
  disabled={loading}
      />
    </div>
  );

  const name = props?.user_profile?.profile_name || props?.user_profile?.username || props?.user_profile_id || "this item";

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-8/20 1xl:w-6/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-mutedGray"
    >
      <div className="w-full">
        <ModalHeader title="Delete Featured Profile" hide={hide} />
        <div className="pl-10 pr-7 py-7">
          <p className="text-lightBlack">
            Are you sure you want to delete ‘<strong>{name}</strong>’?
          </p>
        </div>
      </div>
    </Modal>
  );
}
